<template>
	<Head title="Revisão da prova" />

	<div class="container-fluid mt-3">
		<div class="row">
			<student_info
				:nomeAluno="props.nomeAluno"
				:cpfAluno="props.cpfAluno"
				:computerUID="props.computerUID"
				:totalAnswered="props.totalAnswered"
				:totalQuestions="props.totalQuestions"
				:deadline="props.deadline"
				:feedback_page="props.feedback_page"
				:student_image="props.student_image" />
		</div>
		<div class="row">
			<exam_result
				:score="props.student_score"
				:module_id="props.module_id" />
			<exam_feedback_idle_timer
				:redirect_to="props.redirect_to_agent_start_url" />
		</div>
		<div class="row">
			<exam_feedback_details
				:score="props.student_score"
				:exam_duration="props.exam_duration"
				:deadline="props.deadline"
				:exam_started_at="props.exam_started_at"
				:exam_finished_at="props.exam_finished_at"
				:count_right_answers="props.count_right_answers"
				:count_wrong_answers="props.count_wrong_answers"
				:count_skipped_answers="props.count_skipped_answers"
				:module_id="props.module_id"
				:logout_url="props.logout_url"
				:module_url="props.module_url"
				:continue_course_url="props.continue_course_url" />
		</div>

		<div class="row">
			<div class="col mt-3">
				<div class="card">
					<div class="card-header">
						<h4 id="revision" class="card-title fs-3">
							Revisão da Prova
						</h4>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<exam_questions_review
				:answered_questions="props.answered_questions" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import student_info from '../../components/Exam/student_info.vue';
	import exam_result from '../../components/Exam/exam_result.vue';
	import exam_feedback_details from '../../components/Exam/exam_feedback_details.vue';
	import exam_questions_review from '../../components/Exam/exam_questions_review.vue';
	import { TestQuestion } from 'resources/js/Interfaces/TestQuestion';
	import exam_feedback_idle_timer from '../../components/Exam/exam_feedback_idle_timer.vue';
	import { Head } from '@inertiajs/vue3';
	import { onMounted } from 'vue';
	import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

	const browserWebcam = browserWebcamStreamingStore();

	const props = defineProps({
		nomeAluno: { type: String, required: true },
		cpfAluno: { type: String, required: true },
		computerUID: { type: String, required: true },
		totalQuestions: { type: Number, required: true },
		totalAnswered: { type: Number, required: true },
		deadline: { type: String, required: true },
		feedback_page: { type: Boolean, required: true },
		student_image: { type: String, required: true },
		student_score: { type: Number, required: true },
		module_id: { type: String, required: true },
		exam_duration: { type: Number, required: true },
		exam_started_at: { type: String, required: true },
		exam_finished_at: { type: String, required: true },
		count_right_answers: { type: Number, required: true },
		count_wrong_answers: { type: Number, required: true },
		count_skipped_answers: { type: Number, required: true },
		logout_url: { type: String, required: true },
		module_url: { type: String, required: true },
		continue_course_url: { type: String, required: true },
		answered_questions: { type: Array<TestQuestion>, required: true },
		redirect_to_agent_start_url: { type: String, required: true },
	});

	onMounted(() => {
		browserWebcam.stop('exam-feedback');
	});
</script>
